module.exports = __webpack_public_path__ + "img/Project-1.cef8c04.png";